import script from "./GiftList.vue?vue&type=script&lang=ts&setup=true&name=GiftList"
export * from "./GiftList.vue?vue&type=script&lang=ts&setup=true&name=GiftList"

import "./GiftList.vue?vue&type=style&index=0&id=f2899734&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2899734"]])

export default __exports__